export const voiceCommands = [
  { text: 'Submit PTO for next Monday', category: 'time-off' },
  { text: "What's my leave balance?", category: 'inquiry' },
  { text: 'File my expense from yesterday', category: 'expense' },
  { text: 'Update my emergency contact', category: 'profile' },
  { text: 'Who is my HR representative?', category: 'inquiry' },
  { text: 'Submit my timesheet for last week', category: 'time' }
];

export const mockResults = {
  'Submit PTO for next Monday': {
    task: 'PTO Request Submitted',
    details: 'Leave request for Monday, April 21, 2025 submitted successfully',
    timeSaved: '3m 45s → 8s',
    auditTrail: 'View full audit trail',
    status: 'success'
  },
  "What's my leave balance?": {
    task: 'Leave Balance Retrieved',
    details: 'You have 12 days of PTO remaining for 2025',
    timeSaved: '2m 15s → 3s',
    auditTrail: 'View full audit trail',
    status: 'success'
  },
  'File my expense from yesterday': {
    task: 'Expense Report Created',
    details: 'Expense of $47.50 for client dinner submitted for approval',
    timeSaved: '4m 20s → 12s',
    auditTrail: 'View full audit trail',
    status: 'success'
  }
};

export const problemSteps = [
  { step: 1, title: 'Log into your HR system', description: 'Navigate through authentication and landing pages', time: '25s' },
  { step: 2, title: 'Find the right module', description: 'Search through menus and navigation', time: '45s' },
  { step: 3, title: 'Fill out multiple fields', description: 'Complete forms with various required fields', time: '90s' },
  { step: 4, title: 'Attach documents', description: 'Upload receipts or supporting files', time: '30s' },
  { step: 5, title: 'Submit and wait', description: 'Click submit and wait for confirmation', time: '15s' },
  { step: 6, title: 'Check status later', description: 'Log back in to verify submission', time: '42s' }
];

export const riskTiers = [
  {
    id: 'routine',
    title: 'Routine Tasks',
    description: 'Auto-execute instantly',
    examples: [
      { query: "What's my PTO balance?", response: 'You have 12 days remaining for 2025', instant: true },
      { query: 'Find the remote work policy', response: 'Found: Remote Work Policy v2.3 - Opening document...', instant: true },
      { query: 'Who do I contact for IT support?', response: 'Your IT support contact is tech@company.com', instant: true }
    ],
    color: 'accent-green'
  },
  {
    id: 'important',
    title: 'Important Tasks',
    description: 'Require approval',
    examples: [
      { query: 'Submit time off for next week', response: 'PTO request created. Sent to manager for approval.', instant: false },
      { query: 'File expense for client dinner', response: 'Expense report submitted. Awaiting finance review.', instant: false },
      { query: 'Request work from home equipment', response: 'Equipment request created. IT will review within 24h.', instant: false }
    ],
    color: 'accent-blue'
  },
  {
    id: 'sensitive',
    title: 'Sensitive Tasks',
    description: 'Human oversight required',
    examples: [
      { query: 'Update my bank details', response: 'Security required. We\'ve sent a verification link to your email.', instant: false },
      { query: 'Change my benefit elections', response: 'Benefit changes require HR consultation. Scheduling call...', instant: false },
      { query: 'Request salary adjustment', response: 'This requires manager discussion. Would you like to schedule a 1:1?', instant: false }
    ],
    color: 'accent-orange'
  }
];

export const auditTrailData = [
  {
    id: 1,
    time: '2025-04-15 14:23:45',
    user: 'Sarah Johnson',
    action: 'PTO Request Submitted',
    confidence: '98%',
    status: 'Completed',
    details: {
      userQuery: 'Submit PTO for next Monday',
      interpretation: 'User wants to request time off for Monday, April 21, 2025',
      policiesChecked: ['PTO Policy v3.2', 'Blackout Dates Calendar', 'Team Coverage Requirements'],
      actionTaken: 'Created PTO request #7821 for 1 day, sent to manager Jane Smith',
      undoOption: true
    }
  },
  {
    id: 2,
    time: '2025-04-15 14:18:12',
    user: 'Michael Chen',
    action: 'Expense Report Filed',
    confidence: '95%',
    status: 'Completed',
    details: {
      userQuery: 'File expense for yesterday\'s client dinner at The Steakhouse',
      interpretation: 'User needs to submit business expense of $127.50 from April 14',
      policiesChecked: ['Expense Policy v2.1', 'Per Diem Limits', 'Receipt Requirements'],
      actionTaken: 'Created expense report #3421, attached receipt, sent to finance',
      undoOption: true
    }
  },
  {
    id: 3,
    time: '2025-04-15 14:12:03',
    user: 'Emily Rodriguez',
    action: 'Leave Balance Inquiry',
    confidence: '99%',
    status: 'Completed',
    details: {
      userQuery: 'How many vacation days do I have left?',
      interpretation: 'User wants to check remaining PTO balance',
      policiesChecked: ['PTO Accrual Policy'],
      actionTaken: 'Retrieved balance: 12 days remaining for 2025',
      undoOption: false
    }
  },
  {
    id: 4,
    time: '2025-04-15 13:55:27',
    user: 'David Park',
    action: 'Policy Document Retrieved',
    confidence: '97%',
    status: 'Completed',
    details: {
      userQuery: 'Show me the remote work policy',
      interpretation: 'User needs to access remote work policy document',
      policiesChecked: ['Document Access Rights'],
      actionTaken: 'Opened Remote Work Policy v2.3',
      undoOption: false
    }
  }
];

export const testimonials = [
  {
    id: 1,
    quote: 'Aura cut our HR helpdesk tickets by 70% in month one. Our team finally focuses on strategic work, not answering the same questions repeatedly.',
    author: 'Priya Sharma',
    role: 'CHRO',
    company: '500-person SaaS company',
    impact: '70% ticket reduction'
  },
  {
    id: 2,
    quote: 'The governance console gave our leadership confidence. The audit trails exceed what our current system provides.',
    author: 'Rajesh Kumar',
    role: 'HR Manager',
    company: 'Manufacturing firm',
    impact: 'Enhanced compliance'
  },
  {
    id: 3,
    quote: 'Integration took under 2 weeks. Employees love not remembering which system handles what anymore.',
    author: 'Anita Desai',
    role: 'IT Director',
    company: 'Finance company',
    impact: '2-week implementation'
  }
];

export const features = [
  {
    feature: 'Speed',
    traditional: false,
    aura: true,
    details: 'Tasks completed in seconds vs minutes'
  },
  {
    feature: 'Works across systems',
    traditional: false,
    aura: true,
    details: 'Unified interface for all HR platforms'
  },
  {
    feature: 'Complete audit trail',
    traditional: 'Partial',
    aura: true,
    details: '100% transaction logging with full context'
  },
  {
    feature: 'Risk-based governance',
    traditional: false,
    aura: true,
    details: 'Automatic routing based on task sensitivity'
  },
  {
    feature: 'Voice/chat interface',
    traditional: false,
    aura: true,
    details: 'Natural language interaction'
  },
  {
    feature: 'Mobile-friendly',
    traditional: 'Limited',
    aura: true,
    details: 'Full mobile experience'
  }
];

export const faqs = [
  {
    question: 'How does Aura connect to our HR systems?',
    answer: 'Aura uses secure API connections to integrate with your existing HR platforms (Workday, BambooHR, ADP, etc.). Our implementation team handles the technical setup, typically completed in under 2 weeks. All connections use enterprise-grade encryption and follow SOC 2 compliance standards.'
  },
  {
    question: 'What about security and compliance?',
    answer: 'Security is our foundation. Aura is SOC 2 Type II certified, uses end-to-end encryption, and maintains complete audit trails for every action. We support SSO, role-based access control, and data residency requirements. All sensitive tasks require human approval before execution.'
  },
  {
    question: 'Can actions be reversed?',
    answer: 'Yes. Most actions can be undone within a configurable time window (typically 24 hours). The audit trail shows exactly what happened and when, making it easy to reverse changes. Sensitive actions like payroll or benefit changes always require multi-step verification.'
  },
  {
    question: 'How long is implementation?',
    answer: 'Typical implementation takes 1-2 weeks. This includes connecting to your HR systems, configuring policies, training the AI on your specific workflows, and onboarding your team. We provide dedicated support throughout and after launch.'
  },
  {
    question: 'Which HR platforms does Aura support?',
    answer: 'Aura integrates with major platforms including Workday, BambooHR, ADP, Namely, Gusto, Rippling, and more. We also support custom HRIS systems via API. If you have a specific platform, contact us to confirm compatibility.'
  }
];

export const partners = [
  'SHRM India',
  'NASSCOM HR Tech',
  'Enterprise HR Forum',
  'HR Technology Conference',
  'People Matters'
];